import { useIntl } from 'react-intl';
import { useMutation } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { queryClient } from 'src/config';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

const requestSignature = async (contractUuid: string) => {
  return await putRequest<RequestSimplifiedData>(
    API.PUT.requestSignature(contractUuid),
    null,
    { headers: { Accept: 'application/vnd.falcon.v2+json' } },
  );
};

export const useRequestSignature = () => {
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: requestSignature,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.signatureRequested));
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.CONTRACTS],
      });
    },
    onError: handleError,
  });
};
